export default [
  {
    value: 'INPUT',
    label: '问答题'
  },
  {
    value: 'CHECKBOX',
    label: '多选题'
  }
]
